import { put, select } from 'redux-saga/effects'
import importer from 'common/importer'
const AppointmentsActions = importer('Stores/Appointments/Actions')
const { tokens } = importer('Stores/Users/Select', null)

export default function* success(res) {
  // console.log("gift card success",res)
  const _tokens = yield select(tokens)
  const { token_type, id_token } = _tokens
  const token = `${token_type} ${id_token}`
  const user = yield select(state => state.users.user)
  if(user.role === 'Donor') {
    yield put(AppointmentsActions.getUpcomingAppointments(user.sfid, token))
  }
}

